<template>
  <svg
    class="hadrian-icons ambulatory"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 293.03 396.622"
    style="enable-background: new 0 0 293.03 396.622"
    xml:space="preserve"
  >
    <g>
      <path
        d="M104,31.199c0-8.531-3.066-15.867-9.199-22C88.668,3.067,81.332,0,72.801,0c-8.535,0-15.867,3.067-22,9.199
		c-6.133,6.137-8.934,13.469-8.403,22c-0.531,8.535,2.27,15.735,8.403,21.602c6.133,5.867,13.465,9.066,22,9.598
		c8.531-0.532,15.867-3.731,22-9.598C100.934,46.934,104,39.734,104,31.199L104,31.199z M104,31.199"
      />
      <g>
        <path
          d="M192.801,200L93.602,80c-2.668-4.266-9.469-6.668-20.403-7.199C62.266,72.266,53.867,74.399,48,79.199l-48,87.2
			L11.199,240c6.403,10.668,14.403,12.266,24,4.801c6.934-5.336,8.801-10.402,5.602-15.199l-8-52l20.801-42.403v98.403L4,364.801
			c-2.668,9.066-1.066,16.664,4.801,22.801c5.867,6.132,12.801,8.797,20.801,8c8-0.801,13.332-5.735,16-14.801l56.796-147.199V160
			l-24-33.601c-1.597-1.598-1.464-3.067,0.403-4.399c1.867-1.332,3.597-1.199,5.199,0.399l81.602,96.8
			c4.265,5.868,9.597,8.266,16,7.2c6.398-1.067,10.664-4.133,12.796-9.2C196.535,212.133,196,206.399,192.801,200L192.801,200z
			 M192.801,200"
        />
        <path
          d="M154.398,366.399l-48-120.797l-20,53.597l28,83.2c3.735,8.535,9.735,13.203,18,14c8.27,0.8,14.934-1.868,20-8
			C157.473,382.266,158.141,374.934,154.398,366.399L154.398,366.399z M154.398,366.399"
        />
        <path
          d="M283.199,393.602l0.801,0.797c2.133,2.668,4.535,2.933,7.199,0.8c2.137-2.132,2.403-4.531,0.801-7.199l-91.199-159.199
			c-2.668-2.668-5.332-2.934-8-0.801c-2.133,2.133-2.403,4.535-0.801,7.199L283.199,393.602z M283.199,393.602"
        />
      </g>
    </g>
  </svg>
</template>
